// extracted by mini-css-extract-plugin
export default {"footer":"index_footer_26y9U","foot_link":"index_foot_link_USfl5","list":"index_list_MVpla","link":"index_link_Ovbz1","copyright":"index_copyright_kumL-"};